import React from 'react';
import PropTypes from 'prop-types';

import Overlay from 'components/Overlay';

/**
 * Success Component
 * @param {Node} children               - any additional items: button, image, text, etc.
 * @param {Node} innerContainerChildren - any additional items: button, image, text, etc.
 * @param {Boolean} rendered            - should this item render?
 * @returns {Component}                 - React Component
 */
const MoreInfo = ({ children, innerContainerChildren, rendered }) => (
  <Overlay
    backgroundClass="withBackground"
    rendered={rendered}
    innerContainerChildren={innerContainerChildren}
  >
    {children}
  </Overlay>
);

MoreInfo.propTypes = {
  children: PropTypes.node,
  innerContainerChildren: PropTypes.func,
  rendered: PropTypes.bool,
};

MoreInfo.defaultProps = {
  children: null,
  innerContainerChildren: () => {},
  rendered: null,
};

export default MoreInfo;
